import AuthCard from './AuthCard'

/** Compact in-card wait state so login/signup loading stays in the hero AuthCard. */
const AuthLoadingCard = () => (
  <AuthCard
    title="One moment"
    subtitle="We're getting your partner dashboard ready."
  >
    <div
      className="flex min-h-[168px] flex-col items-center justify-center gap-4"
      role="status"
      aria-live="polite"
    >
      <span className="relative flex h-12 w-12 items-center justify-center">
        <span
          aria-hidden
          className="absolute inset-0 rounded-full bg-primary-tint"
        />
        <span
          aria-hidden
          className="absolute inset-0 rounded-full border-[3px] border-primary-400/25 border-t-primary-300 animate-spin"
        />
      </span>
      <p className="font-open-sans text-[13px] leading-relaxed text-muted">
        This only takes a moment
      </p>
      <span className="sr-only">Loading</span>
    </div>
  </AuthCard>
)

export default AuthLoadingCard
